module.exports = __webpack_public_path__ + "img/35-r.8679cd01.png";